import { tns } from 'tiny-slider';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.singleProduct-gallery__slider').length) {
    tns({
      loop: false,
      container: '.singleProduct-gallery__slider',
      gutter: 10,
      items: 4,
      // autoplay: true,
      // autoplayButtonOutput: false,
      speed: 500,
      lazyload: true,
      lazyloadSelector: '.tns-lazy',
      mouseDrag: true,
      nav: false,
    });

    // set main image
    const items = document.querySelectorAll('.singleProduct-gallery__slider-item');

    items.forEach((item) => {
      item.addEventListener('click', () => {
        const image = item.querySelector('img');
        const main = document.querySelector('.singleProduct-gallery__main');
        const mainImage = main.querySelector('img');

        main.dataset.id = item.id.slice(-1);
        mainImage.src = image.src;
      });
    });

    // gallery
    const mainImage = document.querySelector('.singleProduct-gallery__main');

    mainImage.addEventListener('click', () => {
      const targetImage = mainImage.querySelector('img');

      // build view
      const view = document.createElement('div');
      view.classList.add('gallery-preview');

      const image = document.createElement('img');
      image.src = targetImage.src;

      const buttonClose = document.createElement('button');

      view.addEventListener('click', (e) => {
        const isClick = image.contains(e.target);
        if (!isClick) {
          view.remove();
          document.body.classList.remove('lock');
        }
      });

      view.appendChild(image);
      view.appendChild(buttonClose);

      document.body.appendChild(view);
      document.body.classList.add('lock');
    });
  }
});
